// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PaperLinkElement-cls1___e2f102ee4096808555d{/*!*/}.PaperLinkElement-cls2___ee17b65320b4b7bd236{font-weight:500}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PaperLinkElement-cls1___e2f102ee4096808555d",
	"cls2": "PaperLinkElement-cls2___ee17b65320b4b7bd236 PaperLinkElement-cls1___e2f102ee4096808555d"
};
export default ___CSS_LOADER_EXPORT___;
